import types from "../actions/types";

const initialState = {
  projectProf: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PROJECT_PROFILE:
      return {
        ...state,
        projectProf: action.projectProf
      };
    default:
      return state;
  }
};
